import { useRef } from "react";

const useToast = () => {
  const toastRef = useRef(null);

  const successToast = (str, title) => {
    toastRef.current.show({
      severity: "success",
      summary: title || "Success",
      detail: str || "Operation completed successfully.",
    });
  };

  const errorToast = (error, title, customMessage) => {
    const errorResponse = error?.response?.data?.message;
    toastRef.current.show({
      severity: "error",
      summary: title,
      detail: customMessage || errorResponse || "Some error occurred",
    });
  };

  return {
    successToast,
    errorToast,
    toastRef,
  };
};

export default useToast;
